import { ReactNode } from 'react'
import { Box, BoxProps } from '@mui/material'

interface Props extends BoxProps {
  children: ReactNode
}

const MinimizeTabsWrapper = ({ children, ...props }: Props) => {
  return (
    <Box
      sx={{
        '& .MuiTabs-root': {
          minHeight: ({ spacing }) => spacing(4.5),
        },
        '& .MuiTab-root': {
          fontSize: 13,
          paddingX: ({ spacing }) => spacing(1.5),
          height: ({ spacing }) => spacing(4),
          minHeight: ({ spacing }) => spacing(4.5),
        },
        ...props.sx,
      }}
      {...props}
    >
      {children}
    </Box>
  )
}

export default MinimizeTabsWrapper
